function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "4.5179mm",
    height: "4.2968mm",
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M25 45l-1 0c-6,-4 -12,-8 -17,-13 -5,-6 -7,-12 -7,-19 0,-7 6,-13 13,-13 6,0 10,3 12,6 2,-3 5,-6 11,-6 7,0 13,6 13,13 0,7 -2,13 -7,19 -5,5 -11,9 -16,13l-1 0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ee0fc0d47c110b4bb8e7221a363684c6.svg";
export { ForwardRef as ReactComponent };